import React, { useEffect, useState, useRef } from "react";
import SearchComponent from "../../Search/SearchComponent/SearchComponent";
import "./jurisdicciones.css";
import { Jurisdicciones } from "../../../json/jurisdiccionesInfo";

const JurHidalgo = () => {
  const [search, setSearch] = useState("");
  const searchInput = useRef();
  const juris = Jurisdicciones;

  const searchTram = () => {
    setSearch(searchInput.current.value);
  };

  let filterJurisdicciones = juris.filter((jurisdiccion) => {
    if(jurisdiccion.nombre.toLowerCase().includes(search.toLowerCase())
      || jurisdiccion.direccion.toLowerCase().includes(search.toLowerCase())
      || jurisdiccion.localidad.toLowerCase().includes(search.toLowerCase())
      || jurisdiccion.municipios.toLowerCase().includes(search.toLowerCase())
    ){
      return jurisdiccion;
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Directorio de Jurisdicciones Sanitarias</h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <br></br>
        </div>
      </div>
      {<SearchComponent
        searchInput={searchInput}
        search={search}
        searchTram={searchTram}
      /> }
       <div className="row">
       <div className="table-responsive">
       <table className="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Jurisdicción Sanitaria</th>
              <th>Dirección</th>
              <th>Localidad</th>
              <th>Teléfono</th>
              <th>Georreferencia</th>
              <th>Horario</th>
              <th>Municipios que contempla</th>
            </tr>
          </thead>
          <tbody>
            {filterJurisdicciones.map((item, index) => (
             <tr key={index}> 
                <td><b>{item.nombre}</b></td>
                <td>{item.direccion}</td>
                <td>{item.localidad}</td>
                <td>{item.telefono}</td>
                <td>{item.latitud},{item.longitud}<br></br><a href={`https://www.google.com/maps/search/?api=1&query=${item.latitud},${item.longitud}`} target="_blank">Ver en Google Maps</a></td>
                <td>{item.horario}</td>
                <td>{item.municipios}</td>
              </tr>
            ))}
          </tbody>
      </table> 
      </div> 
      </div>
    </div>
  );
};

export default JurHidalgo;
